import { createContext, useState, useEffect, useContext } from "react";
import * as adminService from "../../services/admin.service";

const AuthContext = createContext(undefined);

// envuelve la app entera y comparte si hay un admin logueado
export function AuthProvider({ children }) {
  const [isLogIn, setIsLogIn] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    adminService.verificarSesion()
      .then(() => setIsLogIn(true))
      .catch(() => setIsLogIn(false))
      .finally(() => setLoading(false));
  }, []);

  function iniciarSesion() {
    setIsLogIn(true);
  }

  // devuelve la promise para que quien llame pueda esperar y despues navegar
  function cerrarSesion() {
    return adminService.logout().catch(() => {}).finally(() => setIsLogIn(false));
  }

  return (
    <AuthContext.Provider value={{ isLogIn, loading, iniciarSesion, cerrarSesion }}>
      {children}
    </AuthContext.Provider>
  );
}

// hook para leer el estado de sesion desde cualquier componente
export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth debe usarse dentro de AuthProvider");
  }
  return context;
}
